// src/utils/flattenMenuTree.js
export const flattenMenuTree = (tree) => {
  const menuMap = {};
  const traverse = (node) => {
    if (node.subName) {
      menuMap[node.subName] = {
        visible: node.visible || false,
        actions: node.actions.reduce((acc, action) => {
          acc[action.name] = action.isEnabled;
          return acc;
        }, {}),
      };
    }
    if (node.children) {
      node.children.forEach(traverse);
    }
  };
  tree.forEach(traverse);
  return menuMap;

  
};